import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { MarkerProps } from './types';
import { testUsersIcon } from '../icons';

export const testUserColor = '#5BBBAA';

export function TestUserMarker({
  color = testUserColor,
  size = 'sm',
  tooltipProps,
  ...props
}: MarkerProps = {}) {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('markers.test-user')} placement="top" mode="title" {...tooltipProps}>
      <Box
        component={FontAwesomeIcon}
        icon={testUsersIcon}
        color={color}
        size={size}
        {...(props as any)}
      />
    </Tooltip>
  );
}
